import { InjectionToken } from '@angular/core';
import { DeviceFleetPort } from './device-fleet.port';

export const DEVICE_FLEET_PORT = new InjectionToken<DeviceFleetPort>('DEVICE_FLEET_PORT');
